const REFERRAL_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

function normalizePhone(value) {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('91')) {
    return digits.slice(2);
  }
  if (digits.length === 11 && digits.startsWith('0')) {
    return digits.slice(1);
  }
  return digits;
}

export function generateReferralCode(fullName, phone) {
  const letters = (fullName || 'DRV')
    .replace(/[^A-Za-z]/g, '')
    .toUpperCase()
    .slice(0, 3)
    .padEnd(3, 'X');
  const last3 = normalizePhone(phone).slice(-3).padStart(3, '0');
  const rand = REFERRAL_ALPHABET[Math.floor(Math.random() * REFERRAL_ALPHABET.length)];
  return `SAR${letters}${last3}${rand}`;
}

export function nextReferralCodeAttempt(fullName, phone) {
  return `${generateReferralCode(fullName, phone)}${
    REFERRAL_ALPHABET[Math.floor(Math.random() * REFERRAL_ALPHABET.length)]
  }`;
}
